<template>
  <div style="height: 100%">
    <SelectableListPane :getListMethod="getMachineListFromFilter" :optional-filters="filters" :paginationEnabled="true"
      :show-filter-tab="true" :show-sorting-tab="true" :itemsPerPage="75" :lockedFilters="mixedFilters" :pk="pk"
      :groupBy="groupByUnitFunction" :dialog-trigger="dialogtrigger" :dialogItem="editItem"
      :scrollcheckTrigger="scrollcheckTrigger" :dialog-method-config="dialogMethodConfig" ref="ListPane"
      :exportFunction="exportFunc" :multiple="true" :allowSelectAll="allowSelectAll" :previewable="true"
      :itemDeleteFunc="itemDeleteFunc" :quickClickFunction="openItem" :onMiddleClick="openInNewTab"
      @select="val => select(val)" @openPreview="item => openPreview(item)" @closePreview="closePreview()">

      <template v-slot:group-header="{ group, items, selectionFilter, setSelectionFilter }">
        <MachineListUnitSubHeader :unit="group" :items="items" :multiple="true" :selectionFilter="selectionFilter"
          :setSelectionFilterFunc="setSelectionFilter" @checkScroll="scrollcheckTrigger++">
        </MachineListUnitSubHeader>
      </template>

      <template v-if="groupByUnitBool"
        v-slot:list-item-wrapper="{ item, index, handleadded, handlechanged, previewable, isPreviewed, showCheckbox, isChecked,
          toggleCheckbox, openPreview, closePreview, handleItemClick, handleMiddleClick, selectionFilter, setSelectionFilter }">
        <SelectableListItemWrapper :index="index" :item="item" :previewable="previewable" :isPreviewed="isPreviewed"
          :showCheckbox="showCheckbox" :isChecked="isCheckedByUnitOrSelf(item, isChecked, selectionFilter)"
          :toggleCheckbox="() => toggleSelectItemUnitContext(item, selectionFilter, setSelectionFilter)"
          :openPreview="openPreview" :closePreview="closePreview" :hide="hideByUnitId(selectionFilter, item.UnitId)"
          @PrimaryClick="handleItemClick(item)" @MiddleClick="handleMiddleClick(item)">
          <template v-slot:list-item>
            <ListItem :machine="item" class="px-1" style="max-width: 100%;" compact @Update="handlechanged">
            </ListItem>
          </template>
        </SelectableListItemWrapper>
      </template>
      <template v-else v-slot:list-item="{ item, handlechanged }">
        <ListItem :machine="item" class="px-1" style="max-width: 100%;" :compact="compact" @Update="handlechanged">
        </ListItem>
      </template>

      <template
        v-slot:select-actions="{ selectionFilter, filter, selectMethod, clearSelectionMethod, refreshListMethod }">
        <MachineSelectionOptions :selectionFilter="selectionFilter" :filter="filter" :selectMethod="selectMethod"
          :customerId="customerId" :clearSelectionMethod="clearSelectionMethod" :refreshListMethod="refreshListMethod"
          hideSetPropperties :selectText="$t('servicesystem.common_objects.commonterms.set_propperties')"
          ref="selectionOptions">
        </MachineSelectionOptions>
      </template>

      <template v-slot:dialog-content="{ item, trigger }">
        <MachineCustomerEditContent :key="'ggg-' + trigger" :editItem="item" :editMode="true" :handleFocus="() => { }"
          class="mt-3">
        </MachineCustomerEditContent>
        <h4 v-text="$t('servicesystem.common_objects.machine.product')" class="px-3" />
        <MachineProductEditContent :key="'lll-' + trigger" :editItem="item" :editMode="true" :handleFocus="() => { }">
        </MachineProductEditContent>
        <h4 v-text="$t('servicesystem.common_objects.commonterms.details')" class="px-3" />
        <MachineDetailsEditContent :key="'jjj-' + trigger" :editItem="item" :editMode="true" :handleFocus="() => { }">
        </MachineDetailsEditContent>
      </template>

    </SelectableListPane>
  </div>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import ListItem from "@/components/ListItems/MachineListItem2.vue";
import SelectableListPane from "@/views/pim/articles/SelectableListPane.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import MachineSelectionOptions from "@/views/job/newjob/cards/machines/MachineSelectionOptions.vue";
import MachineCustomerEditContent from "@/views/admin/machines/MachineCustomerEditContent.vue";
import MachineDetailsEditContent from "@/views/admin/machines/MachineDetailsEditContent.vue";
import MachineProductEditContent from "@/views/admin/machines/MachineProductEditContent.vue";
import MachineListUnitSubHeader from "@/components/ListItems/MachineListUnitSubHeader.vue";
import SelectableListItemWrapper from "@/components/ListItems/SelectableListItemWrapper.vue";

export default {
  name: "MachineListPane3",
  props: {
    pk: String,
    lockedFilters: Object,
    compact: Boolean,
    allowSelectAll: Boolean,
    itemDeleteFunc: Function,
    groupByUnit: Boolean,  //force group by unit
  },
  components: {
    SelectableListPane,
    ListItem,
    MachineSelectionOptions,
    MachineCustomerEditContent,
    MachineDetailsEditContent,
    MachineProductEditContent,
    MachineListUnitSubHeader,
    SelectableListItemWrapper,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data: () => ({
    scrollcheckTrigger: 1,
    editItem: null,
    dialogtrigger: 1,
    dialogMethodConfig: {
      Create: {
        IsClientApiMethod: true,
        Name: 'createMachine',
      },
    },
  }),

  methods: {
    isCheckedByUnitOrSelf(item, isChecked, selectionFilter) {
      const unitInMap = selectionFilter.unitIdMap?.[item.UnitId];
      if (!unitInMap) {
        return isChecked;
      }
      else {
        //if unit in map and select all, check if id is excluded
        if (!selectionFilter.SelectAll) {
          var isExcluded = selectionFilter.excludeItemIdMap?.[item.Id];
          //console.log("unitInMap: ", unitInMap, "Excluded item id: ", item.Id, isExcluded);
          return !isExcluded;
        }
        //unit in map and not select all, check if id is prepended
        else {
          var isPrepended = selectionFilter.prependItemIdMap?.[item.Id];
          //console.log("unitInMap: ", unitInMap, "Prepended item id: ", item.Id, isPrepended);
          return isPrepended;
        }
      }
    },

    hideByUnitId(selectionFilter, unitId) {
      return selectionFilter.hideByUnitId?.[unitId] ?? false;
    },

    toggleSelectItemUnitContext(item, selectionFilter, setSelectionFilterFunc) {
      var copy = Object.assign({}, selectionFilter);

      var writeToExclude = copy.SelectAll;
      const unitInMap = copy.unitIdMap?.[item.UnitId];
      if (unitInMap) {
        writeToExclude = !writeToExclude;
      }

      if (writeToExclude) {
        copy.excludeItemIdMap = { ...copy.excludeItemIdMap, [item.Id]: !copy.excludeItemIdMap?.[item.Id] };
        copy.ExcludeItemIdList = Object.keys(copy.excludeItemIdMap).filter(k => copy.excludeItemIdMap[k]);
      }
      else {
        copy.prependItemIdMap = { ...copy.prependItemIdMap, [item.Id]: !copy.prependItemIdMap?.[item.Id] };
        copy.PrependItemIdList = Object.keys(copy.prependItemIdMap).filter(k => copy.prependItemIdMap[k]);
      }

      setSelectionFilterFunc(copy);
    },

    select() {
      this.$refs.selectionOptions.dialogtrigger2++;
    },

    exportFunc(filters) {
      //console.log("exporting machines", filters);
      clientAPI.methods.exportMachineListFromFilter(filters);
    },

    handleadded(item) {
      this.$refs.ListPane.handleadded(item);
    },
    handlechanged(item) {
      this.$refs.ListPane.handlechanged(item);
    },

    setEditItem(item) {
      this.editItem = item;
      this.dialogtrigger++;
    },

    newEditItem() {
      var customerId = this.customerId;
      var machineModelId = this.lockedFilters?.MachineModelIdList?.[0] ?? this.filters?.MachineModelIdList?.[0] ?? null;
      var machineTypeId = this.lockedFilters?.MachineTypeIdList?.[0] ?? this.filters?.MachineTypeIdList?.[0] ?? null;
      var supplierId = this.lockedFilters?.SupplierIdList?.[0] ?? this.filters?.SupplierIdList?.[0] ?? null;
      var obj = {
        Id: 0,
        CustomerId: customerId,
        MachineModel: machineModelId ? { Id: parseInt(machineModelId) } : undefined,
        MachineType: machineTypeId ? { Id: parseInt(machineTypeId) } : undefined,
        Supplier: supplierId ? { Id: parseInt(supplierId) } : undefined,
        FirmId: this.userInfo.FirmId,
      };
      //console.log("newEditItem", obj);
      this.setEditItem(obj);
    },

    openPreview(item) {
      if (this.$route.query.machineId != item.Id) {
        var query = Object.assign({}, this.$route.query);
        query.machineId = item.Id;
        this.$router.replace({ query });
        if (this.isPhoneBool) { this.$store.state.triggerevents.previewTrigger++; }
      }
    },

    openItem(item) {
      var query = (this.$route.name == "MachineList") ? this.$route.query : undefined; //keep query filters if we are not leaving the current node branch
      this.$router.push({ name: 'MachineInfo', params: { machineId: item.Id }, query })
    },

    closePreview() {
      if (this.$route.query.machineId != undefined) {
        var query = Object.assign({}, this.$route.query);
        query.machineId = undefined;
        this.$router.replace({ query });
        if (this.isPhoneBool) { this.$store.state.triggerevents.previewTrigger++; }
      }
    },

    openInNewTab(item) {
      let newPageRoute = this.$router.resolve({ name: 'MachineInfo', params: { machineId: item.Id } });
      window.open(newPageRoute.href, "_blank");
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          ActiveState: this.getQueryParam("filter-active", 0),
          SupplierIdList: this.getQueryParam("filter-suppliers", []),
          MachineTypeIdList: this.getQueryParam("filter-types", []),
          MachineModelIdList: this.getQueryParam("filter-models", []),
          AssetTypeIdList: this.getQueryParam("filter-asset-types", []),
          CustomerId: this.getQueryParam("filter-customer", ""),
          //ParentCustomerId: this.getQueryParam("filter-parentcustomer", ""),
          //CustomerGroupId: this.getQueryParam("filter-customergroup", ""),
          ServiceAgreementState: this.getQueryParam("filter-serviceagreement", 0),
          OnlyWithActiveContract: this.getQueryParam("filter-onlyactivecontract", "") === "1",
          Sort: this.getQueryParam("filter-sorting", []),
        };
        return filters;
      }
      else {
        return null;
      }
    },

    customerId() {
      return this.lockedFilters?.CustomerId ?? this.filters?.CustomerId ?? null;
    },

    externaltrigger() { return this.$store.state.triggerevents.newTrigger; },

    unitEnabled() {
      return this.$store.state.GlobalSettings.Features.UnitEnabled;
    },

    groupByUnitBool() {
      return this.groupByUnit //prop
        && this.customerId
        && this.unitEnabled
        && (!this.filters?.Sort || this.filters.Sort.length == 0); 
    },

    mixedFilters() {
      const unitSorting = this.groupByUnitBool ? [{ Field: "UnitId", Direction: 1 }] : undefined;
      return { ...this.lockedFilters, Sort: unitSorting }
    },

    groupByUnitFunction() {
      if (this.groupByUnitBool) {
        return (machine) => machine?.Unit ?? { Id: null, Name: this.$t("servicesystem.common_objects.unit.no_unit") };
      }
      else {
        return undefined;
      }
    }
  },

  watch: {
    externaltrigger: function () { this.newEditItem(); }
  },
};
</script>


<style lang="scss" scoped></style>